/**
 * Como cada tipo de coisa se chama na tela — a fonte ÚNICA.
 *
 * Este mapa existia copiado em cinco arquivos (`Busca`, `Entidade`, `PainelGrafo`, `DrawerNoGrafo`,
 * `BadgeCorrelacao`), e as cópias já divergiam: uma delas não conhecia `transacao`, outra deixava
 * `ancora` vazar como se fosse uma espécie de entidade. Rótulo duplicado não fica errado no dia em
 * que se copia — fica errado no dia em que um tipo novo entra e alguém atualiza quatro dos cinco.
 *
 * As ENTIDADES vêm dos descriptors (`tituloSingular`), então um recurso novo se nomeia sozinho.
 * Os RECURSOS-PONTE (telefone, e-mail, endereço) não têm descriptor — não são cadastros, são o que
 * liga cadastros —, e por isso vivem aqui, escritos à mão e de propósito.
 */
import { RECURSOS } from '@/lib/recursos';

/** Recursos compartilhados: existem como nó do grafo e como correlação, nunca como cadastro. */
const PONTES: Record<string, string> = {
  telefone: 'Telefone',
  email: 'E-mail',
  endereco: 'Endereço',
  documento: 'Documento',
};

/** Estados de exibição que o grafo usa como se fossem tipo — não são coisas, são papéis na tela. */
const PAPEIS: Record<string, string> = {
  ancora: 'Âncora',
};

const DAS_ENTIDADES: Record<string, string> = Object.fromEntries(
  Object.values(RECURSOS)
    .filter((d) => d.ownerTipo)
    .map((d) => [
      d.ownerTipo as string,
      d.tituloSingular.charAt(0).toUpperCase() + d.tituloSingular.slice(1),
    ]),
);

/** O rótulo de um tipo, seja ele entidade, ponte ou papel. Nunca devolve vazio. */
export function rotuloTipo(tipo: string): string {
  return DAS_ENTIDADES[tipo] ?? PONTES[tipo] ?? PAPEIS[tipo] ?? tipo;
}

/** O mesmo, no plural do quantificador ("3 pessoas"). Português tem exceções; o `s` cobre estas. */
export function rotuloTipoPlural(tipo: string, quantidade: number): string {
  const base = rotuloTipo(tipo).toLowerCase();
  return quantidade === 1 ? base : `${base}s`;
}

/** É um cadastro navegável (tem ficha e rota), ou só um nó de rede? */
export function ehEntidade(tipo: string): boolean {
  return tipo in DAS_ENTIDADES;
}
